<script>
import { mapGetters } from 'vuex';
import Datamatrix from '@/components/dev/Datamatrix.vue';
import MarkingStatusBadge from '@/components/markings/MarkingStatusBadge.vue';
import LabelArchiveContentsBadge from '../LabelArchiveContentsBadge.vue';

export default {
  name: 'CockpitMatryoshkaColumnQueueItem',
  props: {
    item: Object,
    palletsColumn: Boolean,
  },
  components: { Datamatrix, MarkingStatusBadge, LabelArchiveContentsBadge },
  emits: [
    'select-item',
  ],
  computed: {
    ...mapGetters('debug', ['debug']),
  },
};
</script>

<template>
  <div
    class="queue-item"
    @click.stop="$emit('select-item', item)"
  >
    <div
      v-if="palletsColumn"
      class="mb-1"
    >
      <BBadge
        v-if="item.labelStatus === 'Active'"
        style="font-size: 12px;"
        class="d-inline-flex align-items-center px-2"
      >
        <i class="fas fa-check-circle fa-fw mr-1" />
        <i class="fas fa-pallet-boxes fa-fw mr-2" />
        Zamknięta
      </BBadge>
      <BBadge
        v-else
        style="font-size: 12px;"
        variant="success"
        class="d-inline-flex align-items-center px-2"
      >
        <i class="fas fa-spinner-third fa-spin fa-fw mr-1" />
        <i class="fas fa-pallet-boxes fa-fw mr-2" />
        Otwarta
      </BBadge>
    </div>

    <div class="d-flex align-items-center justify-content-between w-100">
      <Datamatrix
        v-if="item.scanCode && !palletsColumn && debug"
        :encode-string="item.scanCode"
        width="25px"
        height="25px"
        no-tooltip
      />

      <div class="mr-auto">
        ...{{ item.serialNumber }}...
      </div>

      <LabelArchiveContentsBadge
        :label-archive="item"
        :large="palletsColumn"
      />

      <MarkingStatusBadge
        v-if="item.labelStatus && !palletsColumn && false"
        :status="item.labelStatus"
        class="ml-1"
        no-label
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.queue-item {
  border-radius: 6px;
  padding: 4px 8px;
  background-color: white;
  border: 1px solid #F0F1F3;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    background-color: #F0F1F3;
  }

  .left-box {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .right-box {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    margin: auto 0;
    color: #7E7E7E;

    i {
      font-size: 14px;
      margin-right: 5px;
    }
  }

  .pallets-badge {
    font-size: 10px;
    padding: 3px 10px;
    border-radius: 4px;
    color: white;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 4px;

    &--open {
      background-color: #5886C1;
    }

    &--closed {
      background-color: #7CB92D;
    }

    i {
      margin-right: 5px;
    }
  }
}
</style>
